import DayView from "./DayView";

const Appointment = () => {
  return <DayView />;
};

export default Appointment;
